// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5456) return "static/chunks/081ca426-3768696d4e013bb6.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7776 ? "477d4af2" : chunkId) + "." + {"4278":"28b0e11a1bce11d5","5539":"12025e3bf589bcfb","7776":"f606a9c584383585"}[chunkId] + ".js";
};